const DOMAIN_API = "/api/v1"


export function fetch_api_json(method, suffix_url, opts) {
   opts = opts || {}

   opts = {
      method: method,
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
      },
      ...opts,
    }

    return fetch(DOMAIN_API + suffix_url, opts).then((response) => {
        return response.json();
    }).catch((error) => console.error(error));
}


// deletion does not return JSON
function unset_api_json(method, suffix_url) {
    return fetch(DOMAIN_API + suffix_url, {
        method: method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response.status == 204
    }).catch((error) => console.error(error));
}


export function login (email : String,password  : String) {
    const url = DOMAIN_API +"/accounts/log_in"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    }).then((response) => {
        if(response.status==200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}

export function logout () {
    const url = DOMAIN_API +"/accounts/log_out"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        })
    }).then((response) => {
        return response.status == 204
    }).catch((error) => { console.error(error);return false;})
}

export function getFeedNormal(cursor){
  let url = "/post/feed/normal?cursor=";
  if(cursor!=undefined){
      url = url + cursor;
  }

  return fetch_api_json("get", url);
}


export function donwloadFile(url){

    return fetch(url, {
        method: 'get',
        headers: {
            'Content-Type': 'application/octet-stream',
            'Content-Disposition': 'attachment;filename="lapin.pdf"'
        }
    }).then((response) => {
        return response;
    }).catch((error) => console.error(error));

}

export function getFeedFocus(cursor){
  let url = "/post/feed/focus?cursor=";
  if(cursor!=undefined){
      url = url + cursor;
  }
  return fetch_api_json("get", url);
}

export function getAuthorFeed(author,cursor){
  let url = "/post/feed/author?author="+author+"&cursor=";
  if (cursor != undefined) {
      url = url + cursor;
  }

  return fetch_api_json("get", url);
}

export function savePost(idPost : number){

}

export function getPost(idPost : number){
  return fetch_api_json("get", "/post/"+idPost);
}

export function getAllContact(){
  return fetch_api_json("get", "/poi_contact");
}

export function getContact(id){
  return fetch_api_json("get", "/poi_contact/"+id);
}

export function getAllTheme(){
  return fetch_api_json("get", "/poi_theme/tree");
}

export function getTheme(id){
  return fetch_api_json("get", "/poi_theme/"+id);
}

export function getAllEntity(){
  return fetch_api_json("get", "/poi_entity");
}

export function getEntity(id){
  return fetch_api_json("get", "/poi_entity/"+id);
}

export function getBookmark(){
  return fetch_api_json("get", "/bookmark");
}

export function setBookmark(id:number,action:string){
  return fetch_api_json("post", "/bookmark/"+id+"/"+action);
}

export function getFocusContact(){
  return fetch_api_json("get", "/focus_contact");
}

export function getFocusTheme(){
  return fetch_api_json("get","/focus_theme");
}

export function getFocusEntity(){
  return fetch_api_json("get", "/focus_entity");
}

export function setFocusContact(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_contact/"+id+"/"+action)
    : unset_api_json("post", "/focus_contact/"+id+"/"+action);
}

export function setFocusTheme(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_theme/"+id+"/"+action)
    : unset_api_json("post", "/focus_theme/"+id+"/"+action);
}

export function setFocusEntity(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_entity/"+id+"/"+action)
    : unset_api_json("post", "/focus_entity/"+id+"/"+action);
}

export function setNotifyContact(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_contact/"+id+"/"+action)
    : unset_api_json("post", "/notify_contact/"+id+"/"+action);
}

export function setNotifyTheme(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_theme/"+id+"/"+action)
    : unset_api_json("post", "/notify_theme/"+id+"/"+action);
}

export function setNotifyEntity(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_entity/"+id+"/"+action)
    : unset_api_json("post", "/notify_entity/"+id+"/"+action);
}

export function customFeed(cursor,contact,entite,theme){
    const c = cursor === undefined ? "" : cursor;

    const query = {"contacts" : contact, "entities": entite, "themes" : theme, types: []};
    let encode = encodeURIComponent(JSON.stringify(query));

    return fetch_api_json("get", "/post/feed/custom?query="+encode+"&cursor="+c);
}

export function getOneContact(id){
  return fetch_api_json("get", "/poi_contact/"+id);
}

export function getOneEntity(id){
  return fetch_api_json("get", "/poi_entity/"+id);
}

export function getOneTheme(id){
  return fetch_api_json("get", "/poi_theme/"+id);
}

export function getMyProfil(){
    return fetch_api_json("get", "/user/me", {redirect: "error"});
}

export function editMyProfil(user){
    const url = DOMAIN_API +"/user/"+user.id
    return fetch(url,{
        method:"PUT",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            user: user,
        })
    }).then((response) => {
        if(response.status==200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}

export function searchPost(cursor,search){
    const c = cursor === undefined ? "" : cursor;
    return fetch_api_json("get", "/post/search?query="+search+"&cursor="+c);
}


// unused
export function getListComments(id){
    return fetch_api_json("get", "/post/"+id+"/comments");
}


export function addComment(comment){
    const url = DOMAIN_API +"/post/comment"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(comment)
    }).then((response) => {
        if(response.status==200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}

export function getAllUser(){
    return fetch_api_json("get", "/user");
}

export function getProfil(id){
    return fetch_api_json("get", "/user/"+id);
}

export function getTrendingAll(day){
    return fetch_api_json("get", "/trending/all?days="+day);
}

export function checkIFramable(url) {
  // {status: oneOf["error", "unprotected", "protected"]}
  let encode = encodeURIComponent(url);
  return fetch_api_json("get", "/check_iframable?url="+encode);
}


export function getAppConfigJsonValue(key) {
  return fetch_api_json("get", "/app_config/" + key).then(x => {
    try {
      return JSON.parse(x.value)
    } catch(error) {
      return undefined;
    }
  })
}
